import { Dispatch } from 'react';
import { get, remove, put, post } from 'communication/httpClient';
import {
  GET_TENDER_GROUPS,
  ERROR_DATA,
  DELETE_TENDER_GROUP,
  SAVE_TENDER_GROUP,
  UPDATE_TENDER_GROUP,
  GET_TENDER_GROUP,
  CLEAN_TENDER_GROUP,
  SYNCING,
  LOAD_TENDER_GROUPS,
  LOAD_TENDER_GROUP,
  CONTROL_MESSAGE_POPUP,
} from './actionTypes';
import { ITenderGroupAction, ITenderGroupActions, ITenderGroupItem } from './types';

export const getActions = (dispatch: Dispatch<ITenderGroupAction>): ITenderGroupActions => ({
  loadTenderGroups: async () => {
    dispatch({
      type: LOAD_TENDER_GROUPS,
    });
    const { data, error } = await get(`/api/tender-menu-group`);
    if (data) {
      dispatch({
        type: GET_TENDER_GROUPS,
        payload: data,
      });
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
  },
  loadTenderGroup: async (id) => {
    dispatch({
      type: LOAD_TENDER_GROUP,
    });
    const { data, error } = await get(`/api/tender-menu-group/${id}`);
    if (data) {
      dispatch({
        type: GET_TENDER_GROUP,
        payload: data,
      });
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
  },
  deleteTenderGroup: async (id, callback) => {
    dispatch({
      type: SYNCING,
    });
    const { error } = await remove(`/api/tender-menu-group/${id}`);
    if (!error) {
      dispatch({
        type: DELETE_TENDER_GROUP,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
  },
  saveTenderGroups: async (tenderGroup: ITenderGroupItem, groupId, isNew, callback) => {
    const handler = isNew ? post : put;
    const type = isNew ? SAVE_TENDER_GROUP : UPDATE_TENDER_GROUP;
    const { data, error, success } = await handler(
      `/api/tender-menu-group/${groupId}`,
      tenderGroup
    );
    if (data || data === "") {
      dispatch({
        type,
        payload: tenderGroup,
      });
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
    if (success && callback) {
      callback();
    }
  },
  cleanTenderGroup: () => {
    dispatch({
      type: CLEAN_TENDER_GROUP,
    });
  },
  setMessagePopUp: (isOpen) => {
    dispatch({
      type: CONTROL_MESSAGE_POPUP,
      payload: isOpen,
    });
  },
});
